import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-deepseekv3',
  templateUrl: './deepseekv3.component.html',
  styleUrls: ['./deepseekv3.component.scss']
})
export class Deepseekv3Component {
  constructor(private dialogRef: MatDialogRef<Deepseekv3Component>) {}

  close(): void {
    this.dialogRef.close();
  }
}
